import {
	Component,
	ViewEncapsulation,
	Input,
	Output,
	ChangeDetectorRef,
	Inject,
	NgZone,
	OnInit,
	EventEmitter,
	HostListener,
	ChangeDetectionStrategy
} from '@angular/core';

import { EventsService } from '@coreui/services/event.service'
import { UIColorModel } from '@coreui/services/ui.color.model.service';
import { UINavigation } from '@coreui/services/ui.navigation.service';
import { ApplicationService } from '../../services/application.service';


@Component({
	selector: 		'pm-appbar-compact',
	changeDetection: ChangeDetectionStrategy.Default,

	template: 	`
		<div class="_pm-navbar-medium {{_cssShadowClass}} {{_cssAnimationClass}}"
			[style.background-color]=this._surfaceColor>
			<div class="logo" (click)=logoClick()
				[style.opacity]=1>
				<img [src]=getLogo() [style.opacity]=_logoOpacity/>
			</div>
			<div class="fill-remaining-space"></div>
			<div class="action-items" onSurface>
				<div class="item">
					<badge-icon-button [icon]="'bell-outline'" [activeicon]="'bell'" [smallbadge]=true [value]=3 (clicked)=mode($event)></badge-icon-button>				
				</div>
			</div>

			<div class="avatar-wrapper" (click)=hamburgerClick()>
				<avatar40 [imgsrc]="avatarImg"></avatar40>
			</div>
		</div> 

		`,
})


export class AppbarCompactComponent {

	private changeDetectorRef: ChangeDetectorRef
	private eventsService: EventsService
	applicationService: ApplicationService
	uiColorModel: UIColorModel
	uiNavigation: UINavigation
	_surfaceColor: string = ""
	_cssShadowClass: string = ""
	_cssAnimationClass: string = ""
	_logoOpacity: number = 1
	avatarImg: string = "./assets/avatars/gs.png"

	constructor(public ref: ChangeDetectorRef, private _eventsService: EventsService,
		private _uiColorModel: UIColorModel, private _uiNavigation: UINavigation,
		private _applicationService: ApplicationService) {
		this.changeDetectorRef = ref
		this.eventsService = _eventsService
		this.uiColorModel = _uiColorModel
		this.uiNavigation = _uiNavigation
		this.applicationService = _applicationService

		let self = this
		this.eventsService.on('onRefresh', function (args: any) {
			self._surfaceColor = "rgba(0,0,0,0)"
		});
		this.eventsService.on('onScrollStart', function (args: any) {
			self._surfaceColor = "rgba(0,0,0,0.02)"
			self._cssShadowClass = "shadow-1 scale-2"
			self.changeDetectorRef.detectChanges()
		});
		this.eventsService.on('onScrollEnd', function (args: any) {
			self._surfaceColor = "rgba(0,0,0,0)"
			self._cssShadowClass = "scale-1"
			self.changeDetectorRef.detectChanges()
		});
	  
	}

	public getLogo(): string {
		let logo = "./assets/loyalty/logos/peach_marketing_icon.png"
		this._logoOpacity = 1
		if(this.uiColorModel.isDark == true) {
			logo = "./assets/loyalty/logos/peach_marketing_icon.png"
			this._logoOpacity = 0.95
		}
		return logo
	}

	public logoClick(): void {
		this.uiNavigation.activeView = "home"
	}


	public hamburgerClick() {
		this.eventsService.broadcast("onShowModalOverlay", {id: "sidenav-drawer"})
	}


	isDark: boolean = false
	public mode($event: boolean) {
		if(this.isDark == true) {
			this.isDark = false
			this.uiColorModel.darkScheme()
			this.applicationService.activeBackground = "peachy-dark"
			this.eventsService.onRefresh()
		} else {
			this.isDark = true
			this.uiColorModel.lightScheme()
			this.applicationService.activeBackground = "peachy"
			this.eventsService.onRefresh()
		}
	}

	ngOnInit() {
		this._surfaceColor =  "rgba(0,0,0,0)" //this.uiColorModel.surface
	}

	ngOnChanges() {
	}

	ngOnDestroy() {
	}

}
